import { Grid, Typography } from "@mui/material";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLCrest } from "components/CustomIcons/OLCrest";
import { ReactComponent as Laptop01Icon } from "components/Icons/laptop-01.svg";
import { mediaQuery, OLTheme } from "contexts/Theme/ThemeProvider";
import { useMessage } from "hooks/intl";

const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    Grid: {
      backgroundColor: theme.gray50,
      minHeight: "100vh",
      [`@media (min-width: ${mediaQuery.desktop}px)`]: { display: "none" },
      position: "relative",
      zIndex: 9999,
    },
    Info: {
      backgroundColor: theme.primary500,
      color: theme.gray50,
      width: 421,
      maxWidth: "95%",
      padding: theme.spacing(15, 30, 24),
      fontWeight: "normal",
      textAlign: "center",
      boxShadow: "2px 4px 15px rgba(0, 0, 0, 0.2)",
    },
    textBig: {
      fontSize: 20,
      lineHeight: "23px",
      marginTop: theme.spacing(11),
    },
    textSmall: {
      fontSize: 14,
      lineHeight: theme.spacing(11),
      marginTop: theme.spacing(8),
    },
    devices: {
      fontSize: 30,
      marginTop: theme.spacing(17),
    },
    crest: {
      fontSize: 62,
    },
  }),
);
export function UnsupportedDevice() {
  const classes = useStyles();
  const { message } = useMessage();
  return (
    <Grid
      alignItems="center"
      className={classes.Grid}
      container
      direction="column"
      justifyContent="center"
      spacing={0}
    >
      <Grid
        alignItems="center"
        className={classes.Info}
        container
        direction="column"
        justifyContent="center"
        spacing={0}
      >
        <OLCrest className={classes.crest} />
        <Laptop01Icon className={classes.devices} />
        <Typography className={classes.textBig}>
          {message({ id: "unsupportedDeviceHeader" })}
        </Typography>
        <Typography className={classes.textSmall}>
          {message({ id: "unsupportedDeviceInfo" })}
        </Typography>
      </Grid>
    </Grid>
  );
}
